const firebaseConfig = {
    apiKey: "AIzaSyA1BK40YYy-QWMb0pIbp5_DC0Xz3_iCJ74",
    authDomain: "crisp-crypt.firebaseapp.com",
    projectId: "crisp-crypt",
    storageBucket: "crisp-crypt.appspot.com",
    messagingSenderId: "696677035181",
    appId: "1:696677035181:web:fd791447b2a27752422a24"
  };
  export default firebaseConfig;